export default "__VITE_ASSET__DAXhOUkp__"